<nav class="navbar navbar-expand-md bg-dark text-light justify-content-between sticky-top">
    <ul class="navbar-nav mr-2 ml-2">
        <!-- Page title -->
        <a class="navbar-brand text-light text-weight-bolder hover-logo"><i class="fas fa-project-diagram"></i>
            {{logo}}</a>
    </ul>

    <div *ngIf="!identity.isUserAuthenticated()">
        <button type="button" class="btn btn-dark" data-toggle="modal" data-target="#login">
            Log In
        </button>
        <button type="button" class="btn btn-dark" data-toggle="modal" data-target="#create">
            Create account
        </button>
    </div>

    <div *ngIf="identity.isUserAuthenticated()">
        <a class="btn btn-dark" (click)="router.navigate(['/projects'], {queryParams:{userId:identity.getCurrentUserId()}})">My Page</a>
        <a class="btn btn-dark" (click)="identity.logOut()">Log Out</a>
    </div>
</nav>


<div class="d-flex flex-row align-items-center justify-content-center" id="wrap">
    <div id="welcomeImage">
        <div class="w-50 h-100 d-flex justify-content-center">
            <p>
                My name is Cristian Socaci and I built this app to showcase my personal projects.
                You can check them out <a class="btn text-primary p-0" (click)="router.navigate(['/projects'], {queryParams:{userId:0}})">here</a>.
                If you wish to showcase your own projects create an account and start making your presentations.
            </p>
        </div>
    </div>
</div>



 <!-- Log In -->
 <div class="modal fade" id="login">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body">
                <app-login redirect="true"></app-login>
            </div>
        </div>
    </div>
</div>
<!-- Create account-->
<div class="modal fade" id="create">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body">
                <app-create-account></app-create-account>
            </div>
        </div>
    </div>
</div>



